<div class="upload-document-sec">
  <div class="upload-document-sec-header">
    <div class="logo">Syncinns</div>
    <button class="logout-btn" (click)="logout()">Log Out</button>
  </div>
  <div class="upload-document-box">
    <h2>Upload Your Documents</h2>

    <ng-container *ngFor="let doc of requiredDocuments">
      <div class="upload-section">
        <div class="doc-info">
          <div class="d-flex align-items-center">
            <div class="doc-info-icon">
              <img src="assets/images/upload/pdf.png" alt="" />
            </div>
          
            <div class="doc-info-icon-txt">
              <div class="doc-title text-capitalize">{{ doc.doc_name }} upload</div>

              <!-- Rejected Message -->
              <div class="doc-subtitle text-danger" *ngIf="doc.verification_status === 'rejected'">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
                    <path
                      fill="#ED2F29"
                      d="M9.99813 5.74878c-.22102 0-.43298.0878-.58926.24408-.15628.15628-.24408.36824-.24408.58925v5.83459c0 .221.0878.43296.24408.58924.15628.15628.36824.24408.58926.24408.22101 0 .43297-.0878.58924-.24408.15628-.15628.24408-.36824.24408-.58924V6.58211c0-.22101-.0878-.43297-.24408-.58925-.15627-.15628-.36823-.24408-.58924-.24408ZM9.99813 13.9811c-.22102 0-.43298.0878-.58926.244c-.15628.1563-.24408.3683-.24408.5893v.0473c0 .221.0878.433.24408.5892.15628.1562.36824.244 0.58926.244.22101 0 .43297-.0878.58924-.244.15628-.1562.24408-.3682.24408-.5892v-.0473c0-.221-.0878-.433-.24408-.5893-.15627-.1562-.36823-.244-.58924-.244Z"
                    />
                    <path
                      fill="#ED2F29"
                      d="M12.008 2.37525C11.5895 1.64775 10.8382 1.21338 9.99825 1.21338c-.83667 0-1.58563.43437-2.00334 1.16083L.523662 15.3144c-.4225.7348-.4225 1.5779 0 2.3134.416459.7237 1.165629 1.1558 2.003959 1.1558H17.4745c.8387 0 1.5879-.4323 2.0038-1.1558.4229-.7353.4229-1.5784-.0001-2.3146L12.008 2.37525Zm6.0255 14.42165c-.1219.2123-.31.32-.5588.32H2.52762c-.24875 0-.43687-.1079-.55917-.3202-.12437-.2162-.12437-.4354 0-.6502l7.47125-12.9404c.12271-.2133.31604-.326 0.55917-.326.25046 0 .44066.1098.56566.3273l7.4693 12.9389c.1246.216 0.1246.4352 0 0.6516Z"
                    />
                  </svg>
                </span>
                {{doc.rejection_reason}}
              </div>
<div class="doc-subtitle" *ngIf="doc.file_name">
<a [href]="mainUrl + doc.file_name" target="_blank" rel="noopener noreferrer">
  {{ doc.file_name.split('/').pop() }}
</a>
</div>

<div class="doc-subtitle" *ngIf="!doc.file_name">
  Please upload this document (PDF or image, max 5 MB).
</div>
            </div>
          </div>

          <!-- File Name if already uploaded -->
          
        </div>

        <div class="d-flex">
          <div *ngIf="doc.verification_status === 'rejected'"
            class="room-upload-area propform-upload-area Propertyimguploadarea"
             (click)="fileInput.click()"
          >
            <div class="room-upload-icon">
               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M19.5 0.75H4.5C2.84315 0.75 1.5 2.09315 1.5 3.75V20.25C1.5 21.9069 2.84315 23.25 4.5 23.25H19.5C21.1569 23.25 22.5 21.9069 22.5 20.25V3.75C22.5 2.09315 21.1569 0.75 19.5 0.75Z"
                            fill="#DDEBFD"></path>
                          <path
                            d="M17.625 10.844C17.483 10.7105 17.2946 10.6376 17.0997 10.6407C16.9048 10.6438 16.7188 10.7226 16.581 10.8605L13.347 14.0952C13.2064 14.2359 13.1274 14.4266 13.1274 14.6255C13.1274 14.8243 13.2064 15.0151 13.347 15.1557L21.0143 22.8252C21.465 22.563 21.8393 22.1874 22.1 21.7357C22.3606 21.284 22.4985 20.772 22.5 20.2505V15.4257L17.625 10.844Z"
                            fill="#4071F7"></path>
                          <path
                            d="M14.25 10.5C15.4926 10.5 16.5 9.49264 16.5 8.25C16.5 7.00736 15.4926 6 14.25 6C13.0074 6 12 7.00736 12 8.25C12 9.49264 13.0074 10.5 14.25 10.5Z"
                            fill="#5392F9"></path>
                          <path
                            d="M10.2802 9.96882C10.137 9.83332 9.94722 9.75781 9.75 9.75781C9.55278 9.75781 9.36305 9.83332 9.21975 9.96882L1.5 17.6886V20.2491C1.5 21.0447 1.81607 21.8078 2.37868 22.3704C2.94129 22.933 3.70435 23.2491 4.5 23.2491H19.5C20.0215 23.2476 20.5335 23.1096 20.9852 22.849C21.4369 22.5884 21.8125 22.2141 22.0747 21.7633L10.2802 9.96882Z"
                            fill="#5392F9"></path>
                        </svg>
            </div>
            <div class="propform-upload-text">
              Drag Or <a>Click Here</a>
            </div>
          <input
  type="file"
   #fileInput
  style="display: none"
  accept=".pdf,.jpg,.jpeg,.png"
  (change)="onFileSelected($event, doc.doc_id)"
  (click)="resetFileInput(fileInput)"
/>
          </div>

          <!-- Status Icon -->
          <i
            *ngIf="doc.verification_status === 'approved'"
            class="fas fa-check-circle"
            
          ></i>
          <i
            *ngIf="!doc.verification_status || doc.verification_status === 'pending' || doc.verification_status === 'rejected'"
            class="fas fa-times-circle text-danger"
            
          ></i>
        </div>
      </div>
    </ng-container>
  </div>
</div>
